import React, { useEffect, useState, useCallback } from 'react'
import useStatePrev from '../../utils/hooks/useStatePrev'
import LabeledDropdown from '../common/form-components/labeled-dropdown/LabeledDropdown'
import AccountingEntryService from '../../services/accounting-entry/accountingEntry.service'

const AccountSelector = ({
  companyCode,
  value,
  disabled,
  onInit,
  onChange,
  currentRowData,
}) => {
  const [accounts, setAccounts] = useState([])
  const [filterAccount, setFilterAccount, prevFilterAccount] =
    useStatePrev(null)

  useEffect(() => {
    if (currentRowData) {
      retrieveAccounts(currentRowData.accountCode)
    } else {
      retrieveAccounts()
    }
  }, [])
  useEffect(() => {
    if (!currentRowData && prevFilterAccount.current !== filterAccount) {
      retrieveAccounts(filterAccount)
      prevFilterAccount.current = filterAccount
    }
  }, [filterAccount])

  const patchedOnChange = (e) => {
    onChange({
      accountCode: e?.target?.value,
      accountName: accounts.filter(
        (ac) => ac.accountCode === e?.target?.value,
      )[0]?.accountName,
    })
  }

  const retrieveAccounts = useCallback(
    async (customFilter) => {
      const response = await AccountingEntryService.accounts.getAccounts({
        companyCode,
        filter: customFilter,
      })
      if (response && response?.resp) setAccounts(response?.resp)
      onInit({
        accountCode: currentRowData?.accountCode,
        accountName: response?.resp.filter(
          (ac) => ac.accountCode === currentRowData?.accountCode,
        )[0]?.accountName,
      })
    },
    [accounts],
  )

  return (
    <LabeledDropdown
      idLabel="account"
      name="accountCode"
      disabled={disabled}
      required
      options={accounts}
      optionLabel={(rowData) =>
        String(rowData?.accountCode.concat(' - ', rowData?.accountName))
      }
      optionValue="accountCode"
      showClear={value}
      value={value}
      filter
      onChange={patchedOnChange}
      onFilter={(e) => setFilterAccount(e.filter)}
    />
  )
}

export default AccountSelector
